
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReturnItemsGrid extends Serenity.EntityGrid<ECommSalesReturnItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReturnItems'; }
        protected getDialogType() { return ECommSalesReturnItemsDialog; }
        protected getIdProperty() { return ECommSalesReturnItemsRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReturnItemsRow.localTextPrefix; }
        protected getService() { return ECommSalesReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}